module.exports = __webpack_public_path__ + "img/375.8fdd3e13.jpg";